import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';
import { SongFactRow } from './SongFactRow';
import { detailsFactOf, detailsTarget, SongPageTarget } from './songFieldFacts';
import { catalogSongFieldMessages } from './catalogSongFieldMessages';

interface SongDetailsFactProps {
  item: CatalogItem;
  onOpen: (target: SongPageTarget) => void;
}

/**
 * The details that the kit needs and that an unreleased song does not have: the release date (the
 * countdown, the rollout) and the cover art. Nothing when the song has both.
 */
const SongDetailsFactComponent: React.FC<SongDetailsFactProps> = ({ item, onOpen }) => {
  const intl = useIntl();
  const fact = detailsFactOf(item);
  const target = detailsTarget(fact);
  if (target === null) {
    return null;
  }
  const missing = [
    fact.noDate ? intl.formatMessage(catalogSongFieldMessages.noDate) : null,
    fact.noCover ? intl.formatMessage(catalogSongFieldMessages.noCover) : null,
  ].filter((part): part is string => part !== null);

  return (
    <SongFactRow
      label={intl.formatMessage(catalogSongFieldMessages.detailsLabel)}
      text={missing.join(' · ')}
      isProblem
      action={{ label: intl.formatMessage(catalogSongFieldMessages.addDetails), onClick: () => onOpen(target) }}
      testId="song-field-details"
    />
  );
};

export const SongDetailsFact = TypedMemo(SongDetailsFactComponent);
